import React from 'react';
import Row from "../UI/Row";

const ProductsDescriptionBanner = ({showTrial = true}) => {
    return (
        <div className="w-full relative flex flex-col items-center">
            <div className="absolute top-0 left-0 right-0 -z-10">
                <div className="bg-ea_black h-28 w-full "/>
            </div>

            <Row className="justify-around w-full z-10 pt-8 flex-col md:flex-row gap-4" style={{maxWidth: "1200px"}}>
                <div className="flex flex-col w-full md:w-2/5 px-4 md:px-0">
                    <div className="bg-ea_yellow p-2 md:p-6">
                        <div className="font-bold text-xl">ABBONAMENTO BASE</div>
                        <div className="uppercase text-sm">Pacchetto preventivi</div>
                    </div>
                    <div className="bg-gray-100 p-6">

                        {showTrial &&
                        <>
                            <div className="uppercase font-bold mb-2 text-lg">PROVA GRATIS per 15 giorni</div>
                            <div className="text-sm text-gray-500">oppure</div>
                        </>
                        }
                        <Row className="font-bold justify-center gap-1 mt-3">
                            <div>€</div>
                            <div className="text-4xl leading-none">96</div>
                            <div>,00 + IVA</div>
                        </Row>
                        <div className="text-sm text-gray-500">Annuali</div>
                    </div>
                </div>
                <div className="flex flex-col w-full md:w-2/5 px-4 md:px-0">
                    <div className="bg-ea_green_from p-2 md:p-6 text-white ">
                        <div className="font-bold text-xl uppercase">ABBONAMENTO Dinamico</div>
                        <div className="uppercase text-sm">Pacchetto preventivi + consuntivi</div>
                    </div>
                    <div className="bg-gray-100 p-6 ">
                        {showTrial &&
                        <>
                            <div className="uppercase font-bold mb-2 text-lg">PROVA GRATIS per 15 giorni</div>
                            <div className="text-sm text-gray-500">oppure</div>
                        </>
                        }
                        <Row className="font-bold justify-center gap-1 mt-3">
                            <div>€</div>
                            <div className="text-4xl leading-none">125</div>
                            <div>,00 + IVA</div>
                        </Row>
                        <div className="text-sm text-gray-500">Annuali</div>
                    </div>
                </div>
            </Row>
        </div>
    );
};

export default ProductsDescriptionBanner;